import { Icon } from '@dixa/lib-shared-habla';
import { forwardRef } from 'react';

import styles from './styles.module.scss';

type DragHandleProps = JSX.IntrinsicElements['span'];

export const DragHandle = forwardRef<HTMLSpanElement, DragHandleProps>(
  (props, ref) => (
    <span {...props} className={styles.dragHandle} ref={ref}>
      <Icon name="drag" />
    </span>
  ),
);

DragHandle.displayName = 'DragHandle';
